<mat-drawer-container #scrollContainer class="main-drawer scroller h-full" autosize>
  <section class="layout__content h-full">
    <router-outlet />
  </section>
</mat-drawer-container>

@if (showScroll()) {
  <div class="scroll-to-top">
    <button mat-mini-fab color="primary" (click)="scrollTop()">
      <mat-icon class="text-white">arrow_upward</mat-icon>
    </button>
  </div>
}
